<template>
    <ClientOnly>
        <FlippingBook
            :url="url"
            :description="description"
        />
    </ClientOnly>
</template>

<script setup lang="ts">
import type {BaseEmbedProps} from '~/components/BaseEmbed/BaseEmbed.types.js';
import FlippingBook from '~/components/BaseEmbed/FlippingBook.vue';

defineProps<BaseEmbedProps>();

</script>
